module.exports = __webpack_public_path__ + "c601412b4c57a2b487e43f1b53a8ceae.ttf";